import { Typography, Space } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  CalendarOutlined,
} from "@ant-design/icons";

const { Title } = Typography;

const CustomToolBar = (props) => {

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <Title
          level={5}
          style={{ margin: "0 10px 0 0", cursor: "pointer" }}
          onClick={() => {
            props.onNavigate("TODAY");
            props.onView("month");
          }}
        >
          <CalendarOutlined style={{ marginRight: 8 }} />
          Today
        </Title>

        <Space>
          <LeftOutlined
            style={{ fontSize: 16, cursor: "pointer" }}
            onClick={() => props.onNavigate("PREV")}
          />
          <RightOutlined
            style={{ fontSize: 16, cursor: "pointer" }}
            onClick={() => props.onNavigate("NEXT")}
          />
        </Space>

        <span className="rbc-toolbar-label" style={{ marginLeft: 12 }}>
          {props.label}
        </span>
      </div>
    </div>
  );
};

export default CustomToolBar;
